import {ProductItem} from "../../models/Product"

export const getItemsStringWithoutHTML = (itemsArray: ProductItem[]): ProductItem[] =>
    itemsArray.map(item => {
        const {html, productDetails, ...rest} = item
        return rest
    })
